import React from "react"

import OU from "../../Assessts/Images/Home/Parterns/OU.png";
import VNRVJIET from "../../Assessts/Images/Home/Parterns/VNRVJIET.png";
import Assamgovt from "../../Assessts/Images/Home/Parterns/Assam govt.png";
import YDF from "../../Assessts/Images/Home/Parterns/YDF.png";
import P1 from "../../Assessts/Images/Home/Parterns/P1.png";
import P2 from "../../Assessts/Images/Home/Parterns/P2.png";

import CC1 from "../../Assessts/Images/Home/Parterns/CC/CC1.png";
import CC2 from "../../Assessts/Images/Home/Parterns/CC/CC2.png";
import CC3 from "../../Assessts/Images/Home/Parterns/CC/CC3.png";
import CC4 from "../../Assessts/Images/Home/Parterns/CC/CC4.png";

import NGOC1 from "../../Assessts/Images/Home/Parterns/NGOC/NC1.png";
import NGOC2 from "../../Assessts/Images/Home/Parterns/NGOC/NC2.png";
import NGOC3 from "../../Assessts/Images/Home/Parterns/NGOC/NC3.png";
import NGOC4 from "../../Assessts/Images/Home/Parterns/NGOC/NC4.png";
import NGOC5 from "../../Assessts/Images/Home/Parterns/NGOC/NC5.png";
import NGOC6 from "../../Assessts/Images/Home/Parterns/NGOC/NC6.png";
import NGOC7 from "../../Assessts/Images/Home/Parterns/NGOC/NC7.png";
import NGOC8 from "../../Assessts/Images/Home/Parterns/NGOC/NC8.png";

import { Row, Col } from "react-bootstrap";

const Patners = () => {
    const Implementation = [{ img: OU }, { img: VNRVJIET }, { img: Assamgovt }, { img: YDF }, { img: P1 }, { img: P2 }]
const CCollaboration =[{ img: CC1 }, { img: CC2 }, { img: CC3 }, { img: CC4 }]
const NGOCollaboration =[{ img: NGOC1 }, { img: NGOC2 }, { img: NGOC3 }, { img: NGOC4 }, { img: NGOC5 }, { img: NGOC6 }, { img: NGOC7 }, { img: NGOC8 }]
    return (
        <div className="p-4 H-Partners">
            <div className="Web-MainHeading mb-3">Our Partners</div>
            <div className="container-fluid  mb-3 " style={{ width: "fit-content" }}>
                <Row className="dflex gap-5">
                    {Implementation.map((item) => (
                        <Col className="dflex JCCenter alignitems Patners-Implementation" ><img src={item.img} style={{height:"140px"}} /> </Col>
                    ))}
                </Row>
            </div>
             <div className="Web-MainHeading mb-3">Corporate Collaboration​</div>
            <div className="container-fluid  mb-3 " style={{ width: "fit-content" }}>
                <Row className="dflex gap-5">
                    {CCollaboration.map((item) => (
                        <Col className="dflex JCCenter alignitems Patners-Implementation" ><img src={item.img} style={{height:"90px"}} /> </Col>
                    ))}
                </Row>
            </div>

            <div className="Web-MainHeading mb-3">NGO Collaboration​</div>
            <div className="container-fluid  mb-3 " style={{ width: "fit-content" }}>
                <Row className="dflex gap-5">
                    {NGOCollaboration.map((item) => (
                        <Col className="dflex JCCenter alignitems Patners-Implementation" ><img src={item.img} style={{height:"90px"}} /> </Col>
                    ))}
                </Row>
            </div>
        </div>
    )
};
export default Patners;